import HorizontalBox from './HorizontalBox';

export type { HorizontalBoxProps } from './HorizontalBox';

export default HorizontalBox;
